import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

export interface NotificationsStoreState {
  dnd: string | undefined;
  selectedDndOption: string | undefined;
  isDrawerOpen: boolean;
  isDrawerExpanded: boolean;
  showReadNotifications: boolean;
  setDnd: (selectedDndOption: string | undefined, date?: string | undefined) => void;
  setIsDrawerOpen: (open: boolean) => void;
  toggleDrawerExpanded: () => void;
  toggleShowReadNotifications: () => void;
}

const useNotificationsStore = create<NotificationsStoreState>()(
  devtools(
    persist(
      (set) => ({
        dnd: undefined,
        selectedDndOption: undefined,
        isDrawerOpen: false,
        isDrawerExpanded: false,
        showReadNotifications: false,
        setDnd: (selectedDndOption: string | undefined, date?: string | undefined) =>
          set(() => ({
            dnd: date,
            selectedDndOption,
          })),
        setIsDrawerOpen: (open: boolean) =>
          set(() => ({ isDrawerOpen: open, isDrawerExpanded: false })),
        toggleDrawerExpanded: () => set((state) => ({ isDrawerExpanded: !state.isDrawerExpanded })),
        toggleShowReadNotifications: () =>
          set((state) => ({ showReadNotifications: !state.showReadNotifications })),
      }),
      {
        name: 'notifications-storage',
        partialize: (state) => ({
          dnd: state.dnd,
          selectedDndOption: state.selectedDndOption,
        }),
      },
    ),
  ),
);

export default useNotificationsStore;
